<template>
  <div class="relative image-block">
    <div class="image-container">
      <img class="image hidden-xs" v-lazy="'/assets/eg-sellwithus-full.png'" :alt="'Why E-Garderobe image'">
      <img class="image visible-xs" v-lazy="'/assets/mob_4.png'" :alt="'Why E-Garderobe image'">
    </div>
    <div class="absolute flex center-xs text-block">
      <h2 class="center-xs text-block-header">
        {{ $t("Sell with us v2") }}
      </h2>
      <p class="center-xs text-block-paragraph">
        Wypełnij krótki formularz i dodaj swoje rzeczy w kilka chwil. My zajmiemy się resztą!
      </p>
      <button-outline class="text-block-button" :link="'/selling'">
        {{ $t('Fill out the form') }}
      </button-outline>
    </div>
  </div>
</template>

<script>
import ButtonOutline from 'src/themes/theme-egarderobe/components/theme/ButtonOutline.vue'

export default {
  name: 'ImageBlock',
  components: {
    ButtonOutline
  },
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-white: color(white);
  .image-block {
    margin-top: 80px;
    @media (max-width: 767px) {
      margin-top: 40px;
    }
  }
  .image-container {
    @media (max-width: 767px) {
      padding-top: 130%;
      background-color: #d3c7b9;
    }
    position: relative;
    height: 0;
    overflow: hidden;
    padding-top: 25%;
  }
  .image {
    @media (max-width: 767px) {
      top: initial;
      bottom: 0;
      max-width: 80%;
      transform: translate(-50%, 0%);
      left: 50%;
      width: 100%;
    }
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
  .text-block {
    @media (max-width: 767px) {
      top: 25%;
      left: 50%;
      width: 100%;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    top: 50%;
    left: 70%;
    transform: translate(-50%, -50%);
    font-weight: 400;
    min-width: 40%;
  }
  .text-block-header {
    @media (max-width: 1025px) {
      font-size: 24px;
    }
    @media (max-width: 767px) {
      font-size: 30px;
    }
    margin: 0;
    font-size: 42px;
    font-weight: 500;
    color: #000;
  }
  .text-block-paragraph {
    @media (max-width: 1025px) {
      font-size: 14px;
    }
    @media (max-width: 767px) {
      font-size: 16px;
      max-width: 80%;
    }
    margin: 0;
    font-size: 20px;
    color: #000;
    font-weight: 500;
    max-width: 470px;
  }
  .text-block-button {
    @media (max-width: 767px) {
      font-size: 12px;
    }
    width: fit-content;
  }
</style>
